import {
  CloudCadAlignmentStep,
  setStepForCloudCadAlignment,
} from "@/store/modes/cloud-cad-alignment-mode-slice";
import { useAppDispatch } from "@/store/store-hooks";
import { FaroStep } from "@faro-lotv/flat-ui";
import { useMemo, type JSX } from "react";
import { AlignmentStepper } from "../alignment-modes-commons/alignment-stepper";

interface AlignmentProgressBarProps {
  /** A callback that is called when the user wants to apply the alignment */
  apply(): void;
}

/**
 * @returns The bar that is shown in the top of cloud-cad alignment mode
 *  Allows user to see where there are currently in the alignment process, and switch between those steps
 */
export function CloudCadAlignmentProgressBar({
  apply,
}: AlignmentProgressBarProps): JSX.Element {
  const dispatch = useAppDispatch();

  /** defines steps for Cloud-Cad alignment progressbar */
  const steps: FaroStep[] = useMemo(
    () => [
      {
        key: CloudCadAlignmentStep.setElevations,
        label: "Elevation",
        onBeforeNext: () => {
          dispatch(
            setStepForCloudCadAlignment(CloudCadAlignmentStep.alignIn2d),
          );
          return Promise.resolve();
        },
      },
      {
        key: CloudCadAlignmentStep.alignIn2d,
        label: "Align",
        onBeforeBack: () => {
          dispatch(
            setStepForCloudCadAlignment(CloudCadAlignmentStep.setElevations),
          );
          return Promise.resolve();
        },
      },
    ],
    [dispatch],
  );

  return (
    <AlignmentStepper
      steps={steps}
      lastStepButtonText="Confirm Alignment"
      onLastStepButtonClicked={apply}
    />
  );
}
